export enum MissionRewardPopupType {
  BLACK_BUNNY = '검은 토끼의 해 선물',
  VALENTINE = '발렌타인 선물',
  PHOTO_REVIEW = '이달의 리뷰어에 도전',
  REGION_REVIEW_STEP1 = '한 지역 도장 깨기',
  REGION_REVIEW = '방방곡곡 지역 도장 깨기',
  PLACE_CATEGORY_REVIEW = '요즘 내가 꽂힌 음식은?',
  RECEIPT_COLLECTOR = '이달의 영수증 콜렉터',
  RECEIPT_COLLECTOR_2 = '영수증 콜렉터 도전', // 23년 10월 미션부터 이름 변경
  VIDEO_REVIEW = '동영상 리뷰 쓰기',
  NATURE_REVIEW = '자연·지역명소 리뷰 쓰기',
  SUMMER_NATURE_REVIEW = '여름 휴양지 탐험가 도전',
  AUTUMN_NATURE_REVIEW = '가을 명소 탐험가 도전',
  WINTER_NATURE_REVIEW = '겨울 명소 탐험가 도전',
  SPRING_NATURE_REVIEW = '봄 명소 탐험가 도전',
}
